export const buildSearchParams = (
  search,
  { existingParams = null, searchKey = "stringFilter" }
) => {
  let s = ""

  if (search) {
    s = `${searchKey}=${search}`
  }

  return existingParams + (existingParams.includes("?") ? "&" : "?") + s
}

export const linkWithCtrl = (e) => {
  const click = window.open(e, "_blank")
  return click.focus()
}

export function checkDisableInputForecast(year, disable) {
  if (disable) {
    return true
  } else {
    return new Date().getFullYear() < Number(year)
  }
}

export function getLatestMonthNumberInitForecast(e) {
  if (e) {
    if (e.length === 0) {
      return 3
    }
    return Math.max(...e) + 1
  } else {
    return 3
  }
}

export function countListTotal(list, key, { parseNumbers = true, precision = null, defaultValue = 0 } = {}) {
  if (!Array.isArray(list) || !key) return defaultValue

  const getValue = (obj, path) => {
    if (obj == null) return undefined
    if (!path.includes('.')) return obj[path]
    return path.split('.').reduce((acc, p) => (acc == null ? undefined : acc[p]), obj)
  }

  const sum = list.reduce((acc, item) => {
    const raw = getValue(item, key)
    if (raw == null) return acc

    const val = parseNumbers ? Number(raw) : raw
    if (typeof val !== 'number' || Number.isNaN(val)) return acc

    return acc + val
  }, 0)

  if (precision != null && Number.isInteger(precision) && precision >= 0) {
    const factor = 10 ** precision
    return Math.round(sum * factor) / factor
  }

  return sum
}

export const getKeyFromValue = (value, obj) => {
  const entry = Object.entries(obj)
    // eslint-disable-next-line no-unused-vars
    .find(([_, val]) => val === value);
  return entry ? entry[0] : null;
};

export const convertQueryStringToCamelCase = (queryString) => {
  // Remove leading ? if present
  queryString = queryString.startsWith('?') ? queryString.slice(1) : queryString;
  
  const params = new URLSearchParams(queryString);
  const convertedParams = new URLSearchParams();
  
  for (const [key, value] of params) {
    const camelKey = key.replace(/_[a-z]/g, (match) => 
      match.charAt(1).toUpperCase()
    );
    convertedParams.append(camelKey, value);
  }
  
  return '?' + convertedParams.toString();
}

export function countDaysUntil(targetDate, isDateOnly = false) {
  const MS = { DAY: 1000 * 60 * 60 * 24, HOUR: 1000 * 60 * 60, MIN: 1000 * 60 }

  const parseTarget = (d) => {
    if (d instanceof Date) return new Date(d.getTime())
    if (typeof d === "string" && /^\d{4}-\d{2}-\d{2}$/.test(d)) {
      const [y, m, day] = d.split("-").map(Number)
      return new Date(y, m - 1, day) // local midnight to avoid UTC offset issues
    }
    return new Date(d)
  }

  const now = new Date()
  const target = parseTarget(targetDate)

  if (Number.isNaN(target.getTime())) {
    return { days: 0, hours: 0, minutes: 0 }
  }

  if (isDateOnly) {
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const tDate = new Date(target.getFullYear(), target.getMonth(), target.getDate())
    const diffDays = Math.round((tDate - today) / MS.DAY)
    return { days: diffDays, hours: 0, minutes: 0 }
  }

  const diff = target - now
  const sign = diff < 0 ? -1 : 1
  const abs = Math.abs(diff)

  const days = Math.floor(abs / MS.DAY)
  const hours = Math.floor((abs % MS.DAY) / MS.HOUR)
  const minutes = Math.floor((abs % MS.HOUR) / MS.MIN)

  return { days: days * sign, hours: hours * sign, minutes: minutes * sign }
}